function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 16,
  fill: "#12908D",
  stroke: "white",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.5134 7.21449C17.3233 6.8492 16.2133 7.008 15.3924 7.26472C14.5622 7.52449 14 8.31393 14 9.20535V26.0936C14 26.1226 14.0012 26.1514 14.0035 26.18C14.0804 24.9662 15.4037 24 17.025 24C18.3933 24 19.5494 24.6882 19.9231 25.6327V9.15969C19.9231 8.26319 19.3495 7.47122 18.5134 7.21449Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 17,
  cy: 26.2917,
  rx: 3,
  ry: 2.29167,
  fill: "#4A5862"
});

function SvgIconLogbookRebar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogbookRebar);
export default __webpack_public_path__ + "static/media/iconLogbookRebar.68d3f5da.svg";
export { ForwardRef as ReactComponent };